var map = {
	"./IMG_3820.jpg": 6170,
	"./IMG_3823.jpg": 373,
	"./IMG_3830.jpg": 5537,
	"./IMG_3832.jpg": 7267,
	"./IMG_3835.jpg": 4640,
	"./IMG_3871.jpg": 1664,
	"./IMG_3876.jpg": 1827,
	"./deckies_1.jpg": 4717,
	"./deckies_2.jpg": 1810,
	"./deckies_3.jpg": 4479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8920;